import React from "react";
import styled, { css, keyframes } from "styled-components";


const ANIMATION_SPEED = "1.25s"

const moveArrow = keyframes`
  0% {
    bottom: -50%;
  }
  100% {
    bottom: 120%;
  }
`;

const Container = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1DBD6B;
`;


const Arrow = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;

  &::after {
    content: "↑";
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
  }
`;


const ArrowWrapper = styled.div`
  ${() => css`
    position: relative;
    display: grid;
    place-items: center;
  `}

  ${({ shouldAnimate }) => {
    if(!shouldAnimate) return;
    return css`
    animation: ${moveArrow} ${ANIMATION_SPEED} linear infinite;
    animation-delay: ${({ delay }) => delay || "0s"};
    `}
  }
`;

  export const ArrowIconAnimation = ({ shouldAnimate }) => {
  return (
    <Container>
      <ArrowWrapper key={1} shouldAnimate={shouldAnimate} >
        <Arrow />
      </ArrowWrapper> 
    </Container>)
}
